<template>
  <div class="my-4 w-full ">
    <div class="template flex w-full  items-center gap-x-2">
      <span class="badge badge-error mx-2"> {{ question.type }}</span>
      <div>
        <input v-model="question.question" class="input" placeholder="question"/>
      </div>
      <div>
        <select v-model="question.type" class="input">
          <option value="text">text</option>
          <option value="text_long">Text long</option>
          <option value="choices">Choices</option>
          <option value="upload">File</option>
        </select>
      </div>

      <div v-if="question.type === 'upload'">
        <label>`
          <span>Extensions</span>
          <input type="checkbox" :value="question.props.allow_multiple" class="input"/>
        </label>
      </div>
      <div class="flex space-x-4">
        <label class="space-x-2">
          <span>Required</span>
          <input :value="question.required" type="radio" value="true" name="required">
        </label>

        <label class="space-x-2">
          <span>Not</span>
          <input :value="question.required" type="radio" value="false" name="required">
        </label>
      </div>

      <div v-if="question.type === 'choices' || question.type === 'upload'">
        <label>
         <span>
           Allow multiples values
         </span>
          <input type="checkbox" :value="question.props.allow_multiple"/>
        </label>

      </div>

      <div v-if="question.type === 'choices'">
        <button class="btn" @click="add">ADD</button>
      </div>

    </div>
    <div v-if="question.type === 'choices'">
      <div class="mt-2">Choices </div>
      <div v-for="(choice, i) in question.choices">
        <div class="md:flex space-x-2">
          {{i}}
          <label>
            <span>Label</span>
            <input  :value="question.choices[i].value" class="input"/>
          </label>
          <label>
            <span>Value</span>
            <input :value="question.choices[i].label" class="input"/>
          </label>
          <label>
            <button @click.prevent="deleteAt(i)">delete</button>
          </label>
        </div>
      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import {defineProps, PropType, ref, reactive, toRaw} from "vue";

export interface question {
  title: string,
  type: string,
  order: number,
  props: {
    [key: string]: any;
  },
  choices: [
    {
      value: string,
      label: string,
      index : number
    }
  ],
  required: boolean
};

const props = defineProps({
  question: {
    required: true,
    type: Object as PropType<question>,
  }
});
let {question} = props;
//const question : question = reactive(toRaw(question));
let add = () => {
  if (!question.choices) {
    question.choices = [];
  }
  question.choices.push({
    label: null,
    value: null,
    index: question.choices.length
  });
}
let deleteAt = (index) => {
   question.choices.slice(index, index +1 );
   console.log('delete at') ;
}
</script>